import React, { createContext, useContext, useEffect, useState } from "react";

const CustomerContext = createContext();

export const CustomerProvider = ({ children }) => {
  // const [customerID, setCustomerID] = useState("");
  const [customerPhone, setCustomerPhone] = useState("");
  const [customerName, setCustomerName] = useState("new_customer");
  // console.log("customerName -->", customerName);

  const [customerInfo, setCustomerInfo] = useState([]);
  // console.log("customerInfo -->", customerInfo);

  const [customerDataFormPhone, setCustomerDataFormPhone] = useState([]);
  const [isThereCustomerLog, setIsThereCustomerLog] = useState(null);

  //Arama geldiğinde iframe'de açılacak urlin tutulduğu state
  const [didUrl, setDidUrl] = useState({});
  // console.log("didUrl -->", didUrl);

  // const [didInfo, setDidInfo ] = useState(null);
  // console.log("didInfo -->", didInfo);

  const clearCustomerInfo = () => {
    // setCustomerID("");
    setCustomerName("new_customer");
    setCustomerInfo([]);
  };

  // useEffect(() => {
  //   if (Object.keys(customerInfo).length > 0) {
  //     // setCustomerID(customerInfo.customer_id);
  //     // setCustomerName(
  //     //   customerInfo.customer_name + " " + customerInfo.customer_lastname
  //     // );
  //   }
  // }, [customerInfo]);

  const addCall = (call) => {
    // Eğer dizide aynı callerid'ye sahip bir arama yoksa ekle
    setCustomerDataFormPhone((prevCalls) => {
      const isCallExists = prevCalls.some(existingCall => existingCall.callerid === call.callerid);

      // Eğer arama mevcut değilse, yeni aramayı ekle
      if (!isCallExists) {
        return [...prevCalls, call];
      }

      // Eğer arama mevcutsa, diziyi değiştirmeden geri döner
      return prevCalls;
    });
  };

  const value = {
    // customerID,
    // setCustomerID,
    customerName,
    setCustomerName,
    clearCustomerInfo,
    customerPhone,
    setCustomerPhone,
    customerInfo,
    setCustomerInfo,
    customerDataFormPhone,
    setCustomerDataFormPhone,
    addCall,
    // setDidInfo,
    // didInfo,
    isThereCustomerLog,
    setIsThereCustomerLog,
    didUrl,
    setDidUrl,
  };

  return (
    <CustomerContext.Provider value={value}>
      {children}
    </CustomerContext.Provider>
  );
};

export const useCustomer = () => useContext(CustomerContext);
